export default __webpack_public_path__ + "static/media/scoreboard.3996e824.svg";